import DocumentPreview from './DocumentPreview';

import {
  Dialog,
  DialogContent,
  DialogTrigger,
  DialogHeader,
  DialogTitle
} from '@/components/ui/dialog';

const ViewDialog = ({ document, open, setIsOpen }) => {
  return (
    <Dialog open={open} onOpenChange={setIsOpen}>
      <DialogTrigger asChild></DialogTrigger>
      <DialogContent className="max-w-[60vw] ">
        <DialogHeader>
          <DialogTitle>{document.name}</DialogTitle>
        </DialogHeader>
        <DocumentPreview document={document} />
      </DialogContent>
    </Dialog>
  );
};

export default ViewDialog;
